<template>
  <div>
    <router-view :islogin="islogin" :accountbase="accountbase"></router-view>
    <footbottom></footbottom>
  </div>
</template>
<script>
import footbottom from '@/footer'
export default{
    components:{
      footbottom
    },
    props: {
        islogin:Boolean,
        accountbase:Object,
    },
}
</script>



// WEBPACK FOOTER //
// src/admin.vue